import React from 'react';

import * as S from './styles';
import Modal from 'components/Modal';
import MobileBody from 'components/MobileBody';
import { BlogProps } from 'types/BlogProps';
import { returnThumbYoutube } from 'utils/returnJSXs';
import { formatDateBR } from 'utils/functions';

interface PreviewBlogProps {
	isOpenForm: boolean;
	setIsOpenForm: React.Dispatch<React.SetStateAction<boolean>>;
	blogToView: BlogProps | null;
	resetFunction: () => void;
}

export default function PreviewTraining({
	isOpenForm,
	resetFunction,
	setIsOpenForm,
	blogToView
}: PreviewBlogProps) {
	return (
		<Modal
			isOpenProps={isOpenForm}
			setIsOpenModal={() => {
				setIsOpenForm((value) => !value);
				resetFunction();
			}}
			title={`${blogToView?.title}`}
			buttonClose={false}
		>
			<S.container>
				<MobileBody
					backgroundColor="#F5F5F5"
					showHeaderPhone={false}
					heightContentPhone="100%"
				>
					<S.centralize>
						<S.boxApp>
							<S.date>{formatDateBR(blogToView?.date || '')}</S.date>
							<S.title>{blogToView?.title}</S.title>
							<S.subTitle>{blogToView?.subtitle}</S.subTitle>
							<S.img>
								{returnThumbYoutube(
									blogToView?.urlVideo || '',
									blogToView?.title || ''
								)}
							</S.img>

							{blogToView?.content?.length &&
								blogToView?.content?.length > 0 &&
								blogToView?.content.map((item, i) => (
									<React.Fragment key={i}>
										<S.contentHTML
											dangerouslySetInnerHTML={{ __html: item.text }}
										/>
										<S.img>
											{returnThumbYoutube(item?.urlImg || '', item?.text || '')}
										</S.img>
									</React.Fragment>
								))}
						</S.boxApp>
					</S.centralize>
				</MobileBody>
			</S.container>
		</Modal>
	);
}
